console.log(`Loading default.js`);
// Fixed navigation bar functionality using Intersection Observer

// SMOOTH SCROLL — resilient to layout shifts from lazy-loaded images
let scrollGeneration = 0;

document.addEventListener("click", (event) => {
  const anchor = event.target.closest("a[href]");
  if (!anchor) return;

  const rawHref = anchor.getAttribute("href");
  const isHashOnly = rawHref.startsWith("#");
  const url = new URL(rawHref, window.location.href);

  const normalize = (p) =>
    (p || "/").replace(/\/index\.php$/i, "").replace(/\/+$/, "");

  const sameOrigin = url.origin === window.location.origin;
  const sameDoc =
    isHashOnly ||
    normalize(url.pathname) === normalize(window.location.pathname);

  if (url.hash && sameOrigin && sameDoc) {
    const target = document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    history.pushState(null, "", url.hash);
    scrollWithLayoutCorrection(target);
  }
});

function scrollWithLayoutCorrection(target) {
  const gen = ++scrollGeneration;
  let cancelled = false;

  const cancelOnUserScroll = () => { cancelled = true; cleanup(); };
  const userEvents = ["wheel", "touchstart", "keydown"];
  userEvents.forEach((e) => window.addEventListener(e, cancelOnUserScroll, { once: true, passive: true }));

  const cleanup = () => {
    userEvents.forEach((e) => window.removeEventListener(e, cancelOnUserScroll));
  };

  const isStale = () => cancelled || gen !== scrollGeneration;

  target.scrollIntoView({ behavior: "smooth" });

  const pending = [...document.images].filter((img) => !img.complete);
  if (!pending.length) { cleanup(); return; }

  let timer;
  const scheduleCorrection = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (isStale()) return;
      target.scrollIntoView({ behavior: "smooth" });
    }, 120);
  };

  for (const img of pending) {
    img.addEventListener("load", scheduleCorrection, { once: true });
    img.addEventListener("error", scheduleCorrection, { once: true });
  }

  setTimeout(() => {
    if (isStale()) return;
    target.scrollIntoView({ behavior: "smooth" });
    cleanup();
  }, 3000);
}

// DREAMFORM ADAPTION
// DREAMFORM ADAPTION
// DREAMFORM ADAPTION
// hide required * elms and others
document.querySelectorAll('em[aria-hidden="true"]').forEach((el) => {
  el.style.display = "none";
});
document.querySelectorAll("label").forEach((el) => {
  el.style.display = "none";
});
document.querySelectorAll("textarea").forEach((el) => (el.rows = 4));

// ACCORDION
// ACCORDION
// ACCORDION
document.querySelectorAll(".accordion-container").forEach((container) => {
  const head = container.querySelector(".acc-head");
  const body = container.querySelector(".acc-body");
  const inner = body.querySelector(".acc-inner");
  const arrow = head.querySelector("svg");
  let isOpen = false;

  const getFullHeight = () => {
    const style = window.getComputedStyle(inner);
    const marginTop = parseFloat(style.marginTop) || 0;
    const marginBottom = parseFloat(style.marginBottom) || 0;
    return inner.scrollHeight + marginTop + marginBottom;
  };

  head.addEventListener("click", () => {
    isOpen = !isOpen;
    arrow.classList.toggle("!rotate-360", isOpen);

    if (isOpen) {
      // Expand: set height to content's full height including margins
      body.style.height = getFullHeight() + "px";
    } else {
      // Collapse: set height to 0
      body.style.height = "0px";
    }
  });

  // Update height on window resize (in case content reflows)
  window.addEventListener("resize", () => {
    if (isOpen) {
      body.style.height = getFullHeight() + "px";
    }
  });
});

// ACTIVE NAV BAR
// ACTIVE NAV BAR
// ACTIVE NAV BAR
(() => {
  // The section IDs we care about
  const SECTION_IDS = ["shop", "wer", "wann", "b2b", "wo"];

  // Collect existing sections/footer by ID (ignore missing)
  const sections = SECTION_IDS.map((id) => document.getElementById(id)).filter(
    Boolean,
  );

  if (!sections.length) return;
  // on other page then home return
  if (sections.length !== SECTION_IDS.length) return;

  // Map sectionId -> [all matching anchors anywhere on the page]
  const anchorsById = SECTION_IDS.reduce((acc, id) => {
    const anchors = Array.from(
      document.querySelectorAll('a[href*="#"]'),
    ).filter((a) => {
      try {
        const u = new URL(a.href, location.href);
        return u.hash.replace(/^#/, "") === id;
      } catch {
        return a.hash && a.hash.replace(/^#/, "") === id;
      }
    });
    if (anchors.length) acc[id] = anchors;
    return acc;
  }, {});

  // Helper to set the active class on all matching anchors
  let currentActive = null;
  const setActive = (id) => {
    if (id === currentActive) return;
    // Clear all first
    Object.values(anchorsById).forEach((list) =>
      list.forEach((a) => a.classList.remove("is-active")),
    );
    // Set new
    if (id && anchorsById[id])
      anchorsById[id].forEach((a) => a.classList.add("is-active"));
    currentActive = id;
  };

  // Track visible pixel height per section (immune to tall-section bias)
  const visiblePx = new Map(SECTION_IDS.map((id) => [id, 0]));

  const pickMostVisible = () => {
    // "wo" is the footer — if it's visible at all, it always wins
    if (visiblePx.get("wo") > 0) {
      setActive("wo");
      return;
    }

    let bestId = null;
    let bestPx = 0;
    visiblePx.forEach((px, id) => {
      if (px > bestPx) {
        bestPx = px;
        bestId = id;
      }
    });

    const minPx = window.innerHeight * 0.15;
    setActive(bestPx >= minPx ? bestId : null);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        if (!entry.isIntersecting) {
          visiblePx.set(id, 0);
          return;
        }
        const rect = entry.boundingClientRect;
        const vpH = entry.rootBounds?.height ?? window.innerHeight;
        const top = Math.max(rect.top, 0);
        const bottom = Math.min(rect.bottom, vpH);
        visiblePx.set(id, Math.max(0, bottom - top));
      });
      pickMostVisible();
    },
    {
      root: null,
      rootMargin: "0% 0px 0% 0px",
      threshold: [0, 0.05, 0.1, 0.25, 0.5, 0.75, 1],
    },
  );

  sections.forEach((sec) => {
    io.observe(sec);
  });

  // Keep active state correct on hash navigation (e.g., user clicks a nav link)
  window.addEventListener("hashchange", () => {
    const id = location.hash.replace(/^#/, "");
    if (SECTION_IDS.includes(id)) setActive(id);
  });

  // On page load, if we landed on a hash, set it immediately
  const initialId = location.hash.replace(/^#/, "");
  if (SECTION_IDS.includes(initialId)) {
    setActive(initialId);
  }
})();

// NAV BAR SET MARGIN FOR STICKY POSITION
// NAV BAR HIDDEN ON SCROLL TO TOP
// NAV BAR HIDDEN ON SCROLL TO TOP
const navBar = document.querySelector(".nav-bar");
const splash = document.querySelector(".section-splashscreen");
const root = getComputedStyle(document.documentElement);

// Read Tailwind theme var each time (fallback to 900 if missing)
const getBreakpoint = () => {
  const raw = root.getPropertyValue("--breakpoint-mdplus").trim(); // e.g. "900" or "900px"
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : 900;
};

// --- layout: position nav for small screens ---
const positionNavBar = () => {
  const w = window.innerWidth;
  const BP_MDPLUS = getBreakpoint();

  if (w < BP_MDPLUS) {
    const h = window.innerHeight;
    const rect = navBar.getBoundingClientRect();
    const navBarHeightNoMargins = rect.height;
    const topValue = (h - navBarHeightNoMargins) / 2;

    navBar.style.marginTop = `${topValue}px`;
    splash.style.marginTop = `${-topValue - navBarHeightNoMargins}px`;
  }
};

// Single scroll handler registered once (checks viewport each scroll)
const setupScrollBehavior = () => {
  const navImgEl = document.querySelector(".nav-bar img");
  const navBarHideElm = document.querySelector(".nav-bar-hide-elm");
  let isScrolled = false;

  window.addEventListener(
    "scroll",
    () => {
      const scrolled = window.scrollY > 0;
      if (scrolled === isScrolled) return;
      isScrolled = scrolled;

      const isMobile = window.innerWidth < getBreakpoint();
      if (isMobile) {
        if (navImgEl) {
          navImgEl.classList.toggle("!w-82", scrolled);
        }
      } else {
        if (navBarHideElm) {
          navBarHideElm.style.zIndex = scrolled ? "4" : "7";
        }
      }
    },
    { passive: true },
  );
};
if (splash) {
  // ON HOME PAGE
  const runPositionAndSignal = () => {
    positionNavBar();
    window.__navPositionReady = true;
    window.dispatchEvent(new CustomEvent("nav-position-ready"));
  };
  const navImg = navBar.querySelector("img");
  if (navImg && !navImg.complete) {
    navImg.addEventListener("load", runPositionAndSignal, { once: true });
    navImg.addEventListener("error", runPositionAndSignal, { once: true });
  } else {
    runPositionAndSignal();
  }
  setupScrollBehavior();
  let lastWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    const newWidth = window.innerWidth;
    if (newWidth !== lastWidth) {
      positionNavBar();
      lastWidth = newWidth;
    }
    if (newWidth > BP_MDPLUS) {
      splash.style.marginTop = "0";
      navBar.style.marginTop = "0";
    }
  });
} else {
  // ON OTHER PAGES FIXED NAV BAR
  setupScrollBehavior();
  const navBarHideElm = document.querySelector(".nav-bar-hide-elm");
  navBarHideElm.style.zIndex = "4";
}

// SHOW PRODUCTS INGREDIENTS ON TOUCH
// SHOW PRODUCTS INGREDIENTS ON TOUCH
// SHOW PRODUCTS INGREDIENTS ON TOUCH
const hideOnTouchEls = document.querySelectorAll(".hide-on-touch");

function resetAllHideOnTouch() {
  hideOnTouchEls.forEach((el) => (el.style.opacity = "1"));
}

function handleHideOnTouch(e) {
  resetAllHideOnTouch();
  e.currentTarget.style.opacity = "0";
}

hideOnTouchEls.forEach((el) =>
  el.addEventListener("touchstart", handleHideOnTouch),
);

// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
// ON MOBILE SWITCH FORM FIELD NACHRICHT TO BE LAST
const BP_MDPLUS = getBreakpoint();

const form = document.querySelector("[data-b2b-form] form");
const nachrichtGroup = form
  ?.querySelector('textarea[name="nachricht"]')
  ?.closest(".group");
const originalNachrichtParent = nachrichtGroup?.parentElement || null;

if (form) {
  const isCartPath = /\/cart\/?$/.test(window.location.pathname);
  const basePath = window.location.pathname.replace(/\/cart\/?$/, "/");
  const baseUrl = window.location.origin + basePath;
  const action = form.getAttribute("action") || "";
  if (
    isCartPath &&
    (action === "" ||
      action === "/cart" ||
      action === "/cart/" ||
      action.includes("/cart"))
  ) {
    form.setAttribute("action", `${baseUrl}#b2b`);
  }
}

const getRowColumns = (row) =>
  Array.from(row.children).filter((el) => el.tagName === "DIV");

function moveNachrichtField() {
  const w = window.innerWidth;
  if (!form || !nachrichtGroup || !originalNachrichtParent) return;

  const grids = Array.from(form.querySelectorAll(".gap-4.mb-4"));
  if (!grids.length) return;

  const submitRow = grids.find((row) =>
    row.querySelector('button[type="submit"]'),
  );
  if (!submitRow) return;

  const [leftCol, rightCol] = getRowColumns(submitRow);
  if (!leftCol || !rightCol) return;

  const submitBtnGroup = Array.from(rightCol.children).find((el) =>
    el.querySelector('button[type="submit"]'),
  );

  // small screen: move into right column before submit
  if (w < BP_MDPLUS && rightCol !== nachrichtGroup.parentElement) {
    if (submitBtnGroup) {
      rightCol.insertBefore(nachrichtGroup, submitBtnGroup);
    } else {
      rightCol.appendChild(nachrichtGroup);
    }
    nachrichtGroup.querySelector("textarea").style.borderTop = "none";
  }

  // large screen: move back into its original column (if needed)
  if (
    w >= BP_MDPLUS &&
    nachrichtGroup.parentElement !== originalNachrichtParent
  ) {
    originalNachrichtParent.appendChild(nachrichtGroup);
    nachrichtGroup.querySelector("textarea").style.borderTop = "";
  }
}
// initial run
moveNachrichtField();

// STYLE FORM ERROR MESSAGES
// STYLE FORM ERROR MESSAGES
// STYLE FORM ERROR MESSAGES
const submittedFlagKey = "b2b-form-submitted";
const markFormSubmitted = () => {
  form?.classList.add("is-submitted");
  sessionStorage.setItem(submittedFlagKey, "1");
};
if (
  form &&
  sessionStorage.getItem(submittedFlagKey) === "1" &&
  form.querySelector("[data-has-error]")
) {
  form.classList.add("is-submitted");
} else {
  sessionStorage.removeItem(submittedFlagKey);
}
form?.addEventListener("submit", markFormSubmitted);

// CART CHECKOUT FORM VALIDATION (no native tooltip)
// CART CHECKOUT FORM VALIDATION (no native tooltip)
// CART CHECKOUT FORM VALIDATION (no native tooltip)
document.addEventListener(
  "submit",
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("[data-checkout-form]")) return;
    if (form.checkValidity()) return;
    event.preventDefault();
    form.dataset.submitted = "true";
  },
  true,
);

// FIX POS OF "&" IN HERO
// FIX POS OF "&" IN HERO
// FIX POS OF "&" IN HERO
// run on resize with debounce
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(moveNachrichtField, 150);
});

const updateH1FontSize = () => {
  let offset = 28;
  if (window.innerWidth > 1024) offset = 32;
  if (window.innerWidth > 1280) offset = 64;
  // console.log(`offset: ${offset}`);

  const factor =
    window.innerWidth < 900 ? 27.5 : window.innerWidth > 1280 ? 56.5 : 57.5;
  const size = (window.innerWidth - offset) / factor;
  document
    .querySelectorAll(".section-splashscreen *, footer *")
    .forEach((elm) => {
      elm.style.fontSize = `${size}px`;
      // console.log(`h1 font size: ${size}px`);
    });
};

updateH1FontSize();
window.addEventListener("resize", updateH1FontSize);

// STYLE FOCUS COLOR
// STYLE FOCUS COLOR
// STYLE FOCUS COLOR
window.addEventListener("keydown", function (e) {
  // Check if the Tab key (keyCode 9) was pressed
  if (e.key === "Tab" || e.keyCode === 9) {
    document.body.classList.add("is-keyboard-user");
    document.body.classList.remove("is-mouse-user");
  }
});

window.addEventListener("mousedown", function () {
  document.body.classList.add("is-mouse-user");
  document.body.classList.remove("is-keyboard-user");
});
